import { Routes } from '@angular/router';
import { Main } from './layouts/main/main';
import { Landing } from './layouts/landing/landing';
import { HomeComponent } from './home/home.component';

export const routes: Routes = [
  {
    path: '',
    component: Landing,
    children: [{ path: '', component: HomeComponent }],
  },
  {
    path: '',
    component: Main,
    children: [
      {
        path: 'postcards/create',
        loadChildren: () =>
          import('./postcards/create/postcard-create.module').then(
            (m) => m.PostcardCreateModule,
          ),
      },
      {
        path: 'messages',
        loadChildren: () =>
          import('./postcards/share/postcard-list/postcard-list.module').then(
            (m) => m.PostcardListModule,
          ),
      },
      {
        path: 'x/:uid',
        loadChildren: () =>
          import('./postcards/xpost/routes/postcard-from-xpost.module').then(
            (m) => m.PostcardFromXpostModule,
          ),
      },
      {
        path: 'bsky/:user_id/:post_id',
        loadChildren: () =>
          import('./postcards/bsky/routes/postcard-from-bsky.module').then(
            (m) => m.PostcardFromBskyModule,
          ),
      },
      {
        path: 'faq',
        loadChildren: () => import('./faq/faq.module').then((m) => m.FaqModule),
      },
      {
        path: 'campaigns',
        loadChildren: () =>
          import('./campaigns/campaigns.module').then((m) => m.CampaignsModule),
      },
      {
        path: 'tos',
        loadChildren: () =>
          import('./terms/terms.module').then((m) => m.TermsModule),
      },
      {
        path: 'contact',
        loadChildren: () =>
          import('./contact/contact.module').then((m) => m.ContactModule),
      },
      {
        path: 'magic_link/:b64id/:token',
        loadChildren: () =>
          import('./user/magic-link/magic-link.module').then(
            (m) => m.MagicLinkModule,
          ),
      },
      {
        path: 'user',
        loadChildren: () =>
          import('./user/user.module').then((m) => m.UserModule),
      },
    ],
  },
];
